import { LinkingTextResponse } from '../../../api/core/models/api/linking-text-response';
import { NamedLink } from '../../../model/named-link';

export function linkingTextsToNamedLinks(links: LinkingTextResponse[]): NamedLink[] {
  return links.map<NamedLink>((link) => {
    return {
      title: link.title,
      linkUrl: link.linkUrl ?? '',
    };
  });
}
